let skuInfo = {
  name: "查询物料详情",
  updateTime: "2020-05-30 10:00:00",
  methods: 'post',
  url: 'ygw.api.goods.detail.list',
  request: [{
    params: '+context',
    type: "Object[]",
    required: true,
    length: '',
    description: {
      text: '查询物料详情的条件列表',
      value: []
    },
    example: ''
  }, {
    params: '└goodsCode',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '查询物料详情的油柑物料编码',
      value: []
    },
    example: '04SUP000001'
  }],
  reseponse: [{
    params: 'goodsCode',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '油柑物料编码',
      value: []
    },
    example: '04TY000101'
  }, {
    params: 'goodsName',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '物料名称',
      value: []
    },
    example: '贴片电容 0201 NPO 2pF 50V ±0.25pF 厚度 0.3mm'
  }, {
    params: 'brandName',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '品牌名称',
      value: []
    },
    example: '厚生'
  }, {
    params: 'firstCategoryName',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '一级类目名称',
      value: []
    },
    example: '电容'
  }, {
    params: 'secondCategoryName',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '二级类目名称',
      value: []
    },
    example: '钽电容'
  }, {
    params: 'factoryCode',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '原厂编码',
      value: []
    },
    example: 'LMK107BJ106M'
  }, {
    params: 'packingQty',
    type: "Number",
    required: true,
    length: '32',
    description: {
      text: '中包装数',
      value: []
    },
    example: '4000'
  }, {
    params: 'specValue',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '封装',
      value: []
    },
    example: '0603(1608)'
  }, {
    params: 'unitLenth',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '单位长度',
      value: []
    },
    example: '0.40'
  }, {
    params: 'roughWeight',
    type: "Number",
    required: true,
    length: '',
    description: {
      text: '单位重量',
      value: []
    },
    example: '0.036'
  }, {
    params: 'packingUnit',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '中包装名称',
      value: []
    },
    example: '盘'
  }, {
    params: 'productQuantity',
    type: "number",
    required: true,
    length: '64',
    description: {
      text: '商品库存数量',
      value: []
    },
    example: '100000'
  }, {
    params: 'minPurchase',
    type: "number",
    required: true,
    length: '32',
    description: {
      text: '最小起购数',
      value: []
    },
    example: '50'
  }, {
    params: '+goodsPriceList',
    type: "object[]",
    required: true,
    length: '',
    description: {
      text: '价格阶梯',
      value: []
    },
    example: ''
  }, {
    params: '└qtyStart',
    type: "Number",
    required: true,
    length: '32',
    description: {
      text: '阶梯下限',
      value: []
    },
    example: '50'
  }, {
    params: '└qtyEnd',
    type: "number",
    required: true,
    length: '32',
    description: {
      text: '阶梯上线',
      value: []
    },
    example: '950'
  }, {
    params: '└price',
    type: "object",
    required: true,
    length: '',
    description: {
      text: '当前阶梯价格',
      value: []
    },
    example: '0.0012'
  }],
  code: {
    sign: "94c0d23036d9ef73c551c8c49497d802",
    appId: "9527",
    method: "ygw.api.goods.info.list",
    params: JSON.stringify({
      context: {
        goodsCode: '04SUP000001'
      },
      page: {
        currPage: 10,
        pageSize: 20
      }
    })
  }
}


export default skuInfo;